import API from '../../../../../services/api';

export const FACTURAS_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/facturas?page=${page}${search || ''}`).then(res => res.data);
    },
    getPDF: async (idFactura) => {
        return API.get('/facturas/generate_pdf/' + idFactura).then(res => res.data);
    },
    regenerate: async (factura) => {
        return API.post('/facturas-s3', factura).then(res => res.data);
    },
    claimCreditInvoice: async (facturaId) => {
        return API.post('/facturas/' + facturaId + '/reclamar', {}).then(res => res.data);
    },
    sendByEmail: async (facturaId) => {
        return API.post('/facturas/' + facturaId + '/email', null).then(res => res.data);
    },
    export: async (facturas) => {
        return API.post('/facturas/export', facturas, {responseType: 'blob'}).then(res => res.data);
    },
    report: async (data) => {
        return API.post('/facturas/report', data, {responseType: 'blob'}).then(res => res.data);
    },
    compareWithSells: async (facturas) => {
        return API.post('/facturas/compare', facturas, {responseType: 'blob'}).then(res => res.data);
    },
    update: async (factura) => {
        return API.put('/facturas/' + factura.id, factura).then(res => res.data);
    },
    noGenerated: async () => {
        return API.post('/facturas/no-generated').then(res => res.data);
    },
}